import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import VideoPage_2_Ru from "../../common/assets/images/Cepr/VideoPage/VideoPage_2_Ru.png";
import VideoPage_2_En from "../../common/assets/images/Cepr/VideoPage/VideoPage_2_En.png";
import VideoPage_2_De from "../../common/assets/images/Cepr/VideoPage/VideoPage_2_De.png";
import VideoPage_4_Ru from "../../common/assets/images/Cepr/VideoPage/VideoPage_4_Ru.png";
import VideoPage_4_En from "../../common/assets/images/Cepr/VideoPage/VideoPage_4_En.png";
import VideoPage_4_De from "../../common/assets/images/Cepr/VideoPage/VideoPage_4_De.png";
import VideoPage_5_Ru from "../../common/assets/images/Cepr/VideoPage/VideoPage_5_Ru.png";
import VideoPage_5_En from "../../common/assets/images/Cepr/VideoPage/VideoPage_5_En.png";
import VideoPage_5_De from "../../common/assets/images/Cepr/VideoPage/VideoPage_5_De.png";

import PhotoPage_Ru from '../../common/assets/images/Cepr/PhotoPage/GeneralMiniImage.png';
import PhotoPage_En from '../../common/assets/images/Cepr/PhotoPage/GeneralMiniImage_En.png';
import PhotoPage_De from '../../common/assets/images/Cepr/PhotoPage/GeneralMiniImage_En.png';

import MainPage_Ru from "../../common/assets/images/Cepr/MainPage/GeneralLogo_Ru.png";
import MainPage_En from "../../common/assets/images/Cepr/MainPage/GeneralLogo_En.png";
import MainPage_De from "../../common/assets/images/Cepr/MainPage/GeneralLogo_En.png";

import ModelPage_Ru from "../../common/assets/images/Cepr/ModelPage/ModelPage_3_Ru.png";
import ModelPage_En from "../../common/assets/images/Cepr/ModelPage/ModelPage_3_En.png";
import ModelPage_De from "../../common/assets/images/Cepr/ModelPage/ModelPage_3_De.png";


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      ///русский язык
      ru: {
        translation: {
          SwitcherButtom:"Помощь гида",
          Nav:{
            There:{
              photo:"Перейти на главную",
              video:"Перейти к обзору",
              model:"Перейти к демонстрации",
            },
            Back:{
              photo:"Перейти к демонстрации",
              video:"Перейти к характеристикам",
            }
          },
          BrowserLine:{
            MainPage:"АСМ СОЖ",
            PhotoPage:"АСМ СОЖ",
            VideoPage:"АСМ СОЖ",
            ModelPage:"АСМ СОЖ",
          },
          MainPage:{
            Picture:MainPage_Ru,
            SelectPage:"Перейти к следующей странице",
          },
          PhotoPage: {
            Title: "Влияние СОЖ на оборудование",
            Picture:PhotoPage_Ru,
            PhotoPage_1: {
              Title: "Агрессивное воздействие СОЖ на шпиндельный узел",
              Short_Title: "Шпиндельный узел",
              Text: "Коррозия, солевые отложения, повреждение уплотнений и поломки элементов шпиндельного узла возникают вследствие ненадлежащего обслуживания СОЖ, ошибок в приготовлении эмульсии, плохого качества воды, неправильного подбора СОЖ.",
            },
            PhotoPage_2: {
              Title: "Негативное влияние СОЖ на рабочую зону",
              Short_Title: "Рабочая зона",
              Text: "Плохое состояние эмульсии - причина возникновения маслянистых отложений, повреждений лакокрасочного покрытия и появления осадка внутри рабочей зоны станка.",
            },
            PhotoPage_3: {
              Title: "Повреждение инструментальной оснастки",
              Short_Title: "Инструментальная оснастка",
              Text: "Отсутствие обслуживания и ненадлежащее качество смазочно-охлаждающей жидкости приводит к маслянистым отложениям в инструментальном магазине станка.",
            },
            PhotoPage_4: {
              Title:
                "Воздействие на элементы транспортера стружки и резервуар СОЖ",
              Short_Title:
                "Резервуар СОЖ, конвейер",
              Text1:
                "Появление осадка на внутренних поверхностях транспортера стружки.",
              Text2:
                "Накапливание постороннего масла на поверхности СОЖ приводит к биопоражению, снижению производительности обработки, сокращению срока службы эмульсии, маслянистым отложениям внутри станка.",
            },
            PhotoPage_5: {
              Title: "Повышенное пенообразование",
              Short_Title: "Повышенное пенообразование",
              Text: "Высокая концентрация эмульсии, неправильное приготовление СОЖ, качество воды влияют на уровень пенообразования. Большое количество пены приводит к снижению производительности обработки, повышенному расходу концентрата, простоям.",
            },
            PhotoPage_6: {
              Title: "Отложения в трубопроводах станка",
              Short_Title: "Трубопроводы станка",
              Text: "Ненадлежащее обслуживание СОЖ приводит к быстрому росту и накоплению микроорганизмов в системе СОЖ, что значительно снижает полезный срок службы эмульсии.",
            },
            PhotoPage_7: {
              Title: "Влияние СОЖ на обрабатываемые материалы",
              Short_Title: "Обрабатываемые материалы",
              Text: "Отсутствие контроля за состоянием СОЖ вызывает коррозию как цветных, так и черных металлов.",
            },
            PhotoPage_Q: {
              Title: "Справочная информация о СОЖ",
              Short_Title: "Справочная информация о СОЖ",
              Text1: {
                Title: "Назначение СОЖ для металлообработки",
                Text1:
                  "Увеличение срока службы инструмента и качества обработки поверхности",
                Text2:
                  "Обеспечение соответствия необходимым допускам при обработке заготовок",
                Text3: "Удаление стружки и опилок из зоны резания",
                Text4:
                  "Увеличение скорости съема металла и сокращение длительности производственных циклов",
              },
              Text2: {
                Title: "Выбор правильной СОЖ для металлообработки",
                Text1:
                  "_При выборе оптимальной СОЖ для металлообработки необходимо учитывать следующие факторы:",
                Text2: "Обрабатываемый материал или комбинацию материалов.",
                Text3: "Вид обработки (тип обрабатывающей операции).",
                Text4: "Качество воды.",
                Text5: "Отраслевые нормативы и ограничения.",
                Text6: "Система подачи СОЖ для металлообработки.",
                Text7: "Правила охраны труда и техники безопасности.",
              },
            },
          },
          VideoPage: {
            Title: "АСМ СОЖ",
            VideoPage_1: {
              Title: "Решаемые задачи",
              Short_Title: "Решаемые задачи",
              Quotes_1:
                "Стабильный процесс обработки без остановок и простоев.",
              Quotes_2: "Максимальный срок службы СОЖ.",
              Quotes_3:
                "Меньше замен СОЖ, меньше затраты на остановку оборудованияи утилизацию СОЖ.",
              Quotes_4: "Автономность процесса обслуживания СОЖ.",
              Quotes_5:
                "Исключен человеческий фактор: ошибки приготовления и измерения, несвоевременное обслуживание и тд.",
              Quotes_6:
                "Увеличение ресурса оборудования: снижение риска появления коррозии узлов станка, повреждения ЛКП.",
              Quotes_7: "Прозрачная система контроля ключевых параметров СОЖ.",
              Quotes_8:
                "Повышение культуры производства (нет неприятного запаха СОЖ, липких и мокрых полов итп.).",
                Quotes_9:
                "Предотвращение типичных проблем СОЖ.",
            },
            VideoPage_2: {
              Title: "Алгоритм работы станции",
              Short_Title: "Алгоритм работы станции",
              Picture:VideoPage_2_Ru
            },
            VideoPage_3: {
              Title: "Контролируемые параметры СОЖ",
              Short_Title: "Контролируемые параметры СОЖ",
              Table: {
                tableheads: {
                  content1: "Ниже нормы",
                  content2: "Норма",
                  content3: "Выше нормы",
                },
                rows: {
                  rows1: {
                    title: "Концентрация (%)",
                    content1: "Пенообразование (мягкая пена)",
                    content2: "6-10",
                    content3:
                      "Снижение pH\nНеприятный запах\nИзнос инструмента\nНестабильность эмульсии\nКоррозия стали",
                  },
                  rows2: {
                    title: "Кислотность (pH)",
                    content1:
                      "Износ инструмента\nКоррозия стали\nНестабильность эмульсии\nНеприятный запах \nРазмножение бактерий \nПоявление биопленки",

                    content2: "8,5-9,5",
                    content3:
                      "Коррозия алюминия \nБолее агрессивен к коже \nПовреждение окраски \nТенденция пенообразования \nРазрушение пластика и резины",
                  },
                  rows3: {
                    title: "Жесткость (dH)",
                    content1: "Пенообразование (мягкая пена)",
                    content2: "8-45",
                    content3:
                      "Коррозия алюминия\nРасслоение эмульсии\nСолевые отложение \nМасляный осадок на поверхностях\nСнижение ресурса эмульсии",
                  },
                  rows4: {
                    title: "Проводимость (χ)",

                    content1: "",
                    content2: "До 7 mS/cm",
                    content3:
                      "Повышенное содержание солей\nЭлектрохимическая коррозия",
                  },
                },
              },
            },
            VideoPage_4: {
              Title: "Влияние обслуживания на срок службы СОЖ",
              Short_Title: "Срок службы СОЖ",
              Picture:VideoPage_4_Ru
            },
            VideoPage_5: {
              Title: "Снижение расхода СОЖ",
              Short_Title: "Снижение расхода СОЖ",
              Picture:VideoPage_5_Ru
            },
            VideoPage_6: {
              Title: "Решение типичных проблем СОЖ",
              Short_Title: "Решение типичных проблем СОЖ",
              Table: {
                tableheads: {
                  content1: "Возможные причины",
                  content2: "Решение АСМ СОЖ",
                },
                rows: {
                  rows1: {
                    title: "Неприятный запах",
                    content1:
                      "Биопоражение (падение уровня рН) \nМного постороннего масла в баке СОЖ\nЗагрязнения в системе СОЖ",
                    content2:
                      "Регулярный контроль и корректировка уровня рН и концентрации в автоматическом режиме\nУстановка скиммеров для удаления постороннего масла\nФильтр тонкой очистки СОЖ",
                  },
                  rows2: {
                    title: "Пенообразование",
                    content1:
                      "Высокая концентрация эмульсии\nМягкая вода\nВысокая температура эмульсии",

                    content2:
                      "Поддержание концентрации на заданном уровне в автоматическом режиме\nСистема водоподготовки\nДатчики температуры\nПоддержание максимального уровня СОЖ в баке\nСистема дозирования присадок\n",
                  },
                  rows3: {
                    title: "Коррозия",
                    content1:
                      "Низкая концентрация эмульсии\nВысокое содержание солей\nПлохое качество воды\n",
                    content2:
                      "Поддержание концентрации на заданном уровне в автоматическом режиме\nСистема водоподготовки\nКонтроль жесткости эмульсии\n",
                  },
                  rows4: {
                    title: "Аллергические реакции",
                    content1:
                      "Высокая концентрация эмульсии\nВысокий уровень рН\nЗагрязнение эмульсии\nИндивидуальные особенности\n",
                    content2:
                      "Регулярный контроль и корректировка уровня рН и концентрации \nв автоматическом режиме\nТонкая фильтрация СОЖ\n",
                  },
                  rows5: {
                    title: "Маслянистый налет внутри станка",
                    content1:
                      "Нестабильность и расслоение эмульсии\nПопадание инородного масла в систему СОЖ\nВысокое содержание солей в СОЖ\nНеправильное приготовление эмульсии\n",
                    content2:
                      "Контроль основных параметров для поддержания стабильности СОЖ\nСистема водоподготовки для удаления солей жесткости и примесей\nСмеситель для приготовления мелкодисперсной эмульсии\nСкиммер для сбора постороннего масла\n",
                  },
                  rows6: {
                    title: "Белый налет на деталях, в рабочей зоне",
                    content1:
                      "Поступающие вместе с водой в эмульсию соли накапливаются, и при высыхании образуют кристаллизованный налет",
                    content2:
                      "Система водоподготовки для удаления солей жесткости и примесей",
                  },
                  rows7: {
                    title: "Увеличенный расход концентрата",
                    content1:
                      "Увеличение концентрации эмульсии для доливок\nЭмульсия становится все более и более нестабильной из-за накапливания солей или загрязнения инородными маслами",
                    content2:
                      "Система водоподготовки\nКонтроль солесодержания, жесткости эмульсии",
                  },
                },
              },
            },
            VideoPage_7: {
              Title: "Таблица с техническими характеристиками",
              Short_Title: "Технические характеристики",
              Table: {
                tableheads: {
                  content1: "",
                  content2: "Диапазон",
                  content3: "Дискретность",
                  content4: "Точность",
                },
                rows: {
                  rows1: {
                    title: "Общие характеристики",
                    columns1: {
                      content1: "Габаритные размеры",
                      content2: "1400х1800х900",
                      content3: "ДхВхШ, мм",
                    },
                    columns2: {
                      content1: "Масса установки",
                      content2: "750 ",
                      content3: "кг",
                    },
                    columns3: {
                      content1: "Коммуникационные линии:",
                      content2: "",
                      content3: "",
                    },
                    columns4: {
                      content1:
                        "-питание\n-подача воды (магистраль)\n-подача воды (забор)\n- подача СОЖ\n-отвод СОЖ\n-коммуникация СЧПУ",
                      content2: "220\n20\n20\n12\n12",
                      content3: "В\nл/мин\nл/мин\nл/мин\nл/мин",
                    },
                    columns5: {
                      content1: "Бак чистой воды",
                      content2: "250",
                      content3: "л",
                    },
                    columns6: {
                      content1: "Бак концентрата",
                      content2: "40",
                      content3: "л",
                    },
                    columns7: {
                      content1: "Фильтр СОЖ",
                      content2: "100",
                      content3: "мкм",
                    },
                    columns8: {
                      content1: "Фильтр воды",
                      content2: "",
                      content3: "",
                    },
                    columns9: {
                      content1:
                        "-1 ступень (БА)\n-2 ступень(РР)\n-3 ступень (СВС)",
                      content2: "10\n5\n0,6",
                      content3: "мкм\nмкм\nмкм",
                    },
                    columns10: {
                      content1: "Смеситель концентрата",
                      content2: "6-16",
                      content3: "%",
                    },
                    columns11: {
                      content1: "Датчики давления (4 точки)",
                      content2: "0-25",
                      content3: "бар",
                    },
                    columns12: {
                      content1: "Датчики уровня жидкости (2 точки)",
                      content2: "0-1500 (0-150)",
                      content3: "мм",
                    },
                    columns13: {
                      content1: "Циркуляционные насосы (2 шт)",
                      content2: "60",
                      content3: "л/мин",
                    },
                    columns14: {
                      content1: "Коммуникационные протоколы",
                      content2:
                        "Web-server, MySQL, OPC UA, MQTT, OwenCloud, HTTP",
                      content3: "",
                    },
                    columns15: {
                      content1: "Общая потребляемая мощность",
                      content2:
                        "3.5",
                      content3: "кВт",
                  },
                  },
                  rows2: {
                    title: "Система управления",
                    columns1: {
                      content1: "Панель управления-контроллер",
                      content2: "ОВЕН СПК107",
                    },
                    columns2: {
                      content1: "Количество цифровых входов",
                      content2: "12",
                    },
                    columns3: {
                      content1: "Количество цифровых выходов",
                      content2: "20",
                    },
                    columns4: {
                      content1: "Количество аналоговых входов",
                      content2: "16",
                    },
                    columns5: {
                      content1: "Коммуникационные интерфейсы",
                      content2:
                        "Ethernet, 3xRS-485, 2xRS-232,USB Host, USB Device, SD-card",
                    },
                    columns6: {
                      content1: "Протоколы обмена данными",
                      content2:
                        "Modbus (RTU, ASCII,TCP),OBEH,OPC UA (Server), SNMP (Manager/Agent)",
                    },
                  },
                  rows3: {
                    title: "Подсистема управления pH",
                    columns1: {
                      content1: "pH",
                      content2: "0-15",
                      content3: "0,01",
                      content4: "±0,02",
                    },
                    columns2: {
                      content1: "Температура, ℃",
                      content2: "0-100",
                      content3: "0,1",
                      content4: "±0,3",
                    },
                  },
                  rows4: {
                    title: "Подсистема измерения УЭП/Солесодержания",
                    columns1: {
                      content1: "УЭП, мкСм/см",
                      content2: "0-200",
                      content3: "0,0001",
                      content4: "±(0,001+0,02*æ)",
                    },
                    columns2: {
                      content1: "Солесодержание, мг/дм3",
                      content2: "0-100",
                      content3: "0,0001",
                      content4: "±(0,001+0,025*С)",
                    },
                  },
                  rows5: {
                    title: "Подсистема измерения концетрации",
                    columns1: {
                      content1: "Преломление",
                      content2: "1,3200-1,5400",
                      content3: "0,0001",
                      content4: "±0,0002",
                    },
                    columns2: {
                      content1: "Концентрация, %",
                      content2: "0-90",
                      content3: "0,005",
                      content4: "0,005",
                    },
                    columns3: {
                      content1: "Материал призмы",
                      content2: "Синтетический сапфир",
                      content3: "",
                      content4: "",
                    },
                  },
                },
              },
            },
          },
          ModelPage: {
            Section_1: {
              Title: "Правая секция",
              Short_Title: "Правая секция",
              Points: {
                Points_1: {
                  Title: "Подсистема измерений",
                  Text: `•	Кондуктометр\n•	dH-метр / солемер\n•	pH-метр / ЭДС\n•	Рефрактометр\n•	4 датчика давления на каскадах фильтров\n• 2 датчика уровня (резервуар чистой воды, бак концентрата)\n•	3 датчика температуры`,
                },
                Points_2: {
                  Title: "Подсистема очистки СОЖ",
                  Text: `•	Тонкая фильтрация СОЖ от механических примесей`,
                },
                Points_3: {
                  Title: "Подсистема управления",
                  Text: `•	Промышленный контроллер с сенсорным управлением\n•	4 режимы работы АСМ СОЖ\n•	Выполнение доливок эмульсии и поддержание заданного уровня СОЖ в баке\n•	Добавление специальных присадок в СОЖ, при необходимости`,
                },
                Points_4: {
                  Title: "Подсистема циркуляции и гидрорегулирования",
                  Text: `•	Подача и контроль жидкости\n•	Режим циркуляции СОЖ, в том числе для неработающих станков`,
                },
              },
            },
            Section_2: {
              Title: "Подсистема хранения данных и визуализации",
              Short_Title: "Подсистема хранения данных и визуализации",
              Text: `•	Панель мониторинга состояния СОЖ
              •	Web-интерфейс для взаимодействия с АСМ СОЖ
              •	Достоверная система отчетности, хранение данных в БД, предиктивная аналитика
              •	Система оповещения о нештатных ситуациях и проведению регламентных работ`,
            },
            Section_3: {
              Title: "Основные функции",
              Short_Title: "Основные функции",
              Picture:ModelPage_Ru
            },
            Section_4: {
              Title: "Левая секция",
              Short_Title: "Левая секция",
              Points: {
                Points_1: {
                  Title: "Система водоподготовки и приготовления эмульсии",
                  Text: `•	Стабильно высокое качество очистки воды(Каскад из 3 ступеней очистки)\n• Бак подготовленной воды\n• Автоматический смеситель для приготовления мелкодисперсной однородной эмульсии\n•	Точная настройка необходимой концентрации эмульсии`,
                },
                Points_2: {
                  Title: "Бак подготовленной воды",
                },
                Points_3: {
                  Title: "Система дозирования присадок",
                  Text: `•	Комплект из трех дозирующих насосов и резервуаров с алгоритмом добавления  присадок по мере потребности`,
                },
              },
            },
            Section_5: {
              Title: "Задняя секция",
              Short_Title: "Задняя секция",
            },
          },
        },
      },

      ///английский язык
      en: {
        translation: {
          SwitcherButtom:"Help guide",
          BrowserLine:{
            MainPage:"ASM coolant",
            PhotoPage:"ASM coolant",
            VideoPage:"ASM coolant",
            ModelPage:"ASM coolant",
          },
          Nav:{
            There:{
              photo:"Go to Main page",
              video:"Go to overview",
              model:"Go to demo",
            },
            Back:{
              photo:"Go to demo",
              video:"Go to specifications",
            }
          },
          MainPage:{
            Picture:MainPage_En,
            SelectPage:"Go to next page",
          },
          PhotoPage: {
            Title: "Effect of coolant on equipment",
            Picture:PhotoPage_En,
            PhotoPage_1: {
              Title: "Aggressive coolant action on a spindle unit",
              Short_Title: "Aggressive coolant action on a spindle unit",
              Text: "Corrosion, salt deposits, damage of seals and breakdown of spindle unit components develop due to improper coolant maintenance, inaccurate emulsification, poor quality of water, and improper coolant selection.",
            },
            PhotoPage_2: {
              Title: "Detrimental coolant effect on the operating area",
              Short_Title: "Detrimental coolant effect on the operating area",
              Text: "Poor emulsion condition causes oily deposits, paint coating damage and sludge buildup inside the machine operating area.",
            },
            PhotoPage_3: {
              Title: "Tooling damage",
              Short_Title: "Tooling damage",
              Text: "Lack of maintenance and inadequate coolant quality causes oily deposits in the machine tool changer.",
            },
            PhotoPage_4: {
              Title:
                "Impact on chip scrap conveyor components and coolant tank ",
              Short_Title:
                "Impact on chip scrap conveyor components and coolant tank ",
              Text1:
                "Sludge buildup on the inside of the chip scrap conveyor.",
              Text2:
                "Accumulation of foreign oil on the coolant surface results in biodestruction, degradation of machining efficiency, decrease in emulsion service life, and oily deposits inside the machine.",
            },
            PhotoPage_5: {
              Title: "Excessive foaming",
              Short_Title: "Excessive foaming",
              Text: "High emulsion concentration, improper coolant preparation and water quality affect foaming volume. Excessive foam amount causes degradation of machining efficiency, higher concentrate consumption and downtimes.",
            },
            PhotoPage_6: {
              Title: "Deposits in the machine pipelines",
              Short_Title: "Deposits in the machine pipelines",
              Text: "Improper coolant maintenance results in rapid microbial growth and accumulation in the coolant system, which dramatically reduces the emulsion useful life.",
            },
            PhotoPage_7: {
              Title: "Effect of coolant on materials being machined",
              Short_Title: "Effect of coolant on materials being machined",
              Text: "Lack of coolant condition monitoring causes corrosion of both ferrous and non-ferrous metals.",
            },
            PhotoPage_Q: {
              Title: "Coolant reference information",
              Short_Title: "Coolant reference information",
              Text1: {
                Title: "Purpose of coolant for metalworking",
                Text1:
                  "Increase of tool service life and improvement of surface machining quality.",
                Text2:
                  "Ensuring compliance with the required tolerances in workpiece machining.",
                Text3: "Removal of chips and shavings from the cutting area.",
                Text4:
                  "Increase of metal removal rate and reduction of production cycle duration.",
              },
              Text2: {
                Title: "Selection of proper coolant for metalworking",
                Text1:
                  "_When selecting the best coolant for metalworking, the following factors shall be considered:",
                Text2: "Material or combination of materials to be machined.",
                Text3: "Type of machining (type of machining operation).",
                Text4: "Water quality.",
                Text5: "Industry standards and restrictions.",
                Text6: "Coolant supply system for metalworking.",
                Text7: "Occupational health and safety rules."
              },
            },
          },
          VideoPage: {
            Title: "Automatic multi-machine station for coolant monitoring and parameter tuning",
            VideoPage_1: {
              Title: "Issues to be solved",
              Short_Title: "Issues to be solved",
              Quotes_1:
                "Stable machining process without shutdowns and downtimes.",
              Quotes_2: "Maximum coolant service life.",
              Quotes_3:
                "Fewer coolant replacements, less equipment downtime and coolant disposal costs.",
              Quotes_4: "Independence of coolant maintenance process.",
              Quotes_5:
                "Exclusion of man-made factor: errors in preparation and measurements, untimely maintenance, etc.",
              Quotes_6:
                "Extension of equipment life: reduction of risk of corrosion in machine units and damage to painting system.",
              Quotes_7: "Transparent system of coolant key parameter control.",
              Quotes_8:
                "Enhancement of production practice (no unpleasant ordour of coolant, sticky and wet floors, etc.).",
                Quotes_9:
                "Prevention of typical coolant problems.",
            },
            VideoPage_2: {
              Title: "Operating algorithm",
              Short_Title: "Operating algorithm",
              Picture:VideoPage_2_En
            },
            VideoPage_3: {
              Title: "Coolant parameters",
              Short_Title: "Coolant parameters",
              Table: {
                tableheads: {
                  content1: "Below normal",
                  content2: "Normal",
                  content3: "Above normal",
                },
                rows: {
                  rows1: {
                    title: "Concentration (%)",
                    content1: "Decrease in pH level\nUnpleasant odour\nTool wear\nEmulsion instability\nSteel corrosion",
                    content2: "6-10",
                    content3:
                      "Foaming\nAggressive action on skin\nOil burning, fumes\nSludge buildup\nHigh concentrate consumption",
                  },
                  rows2: {
                    title: "Acidity (pH)",
                    content1:
                      "Tool wear\nSteel corrosion\nEmulsion instability\nUnpleasant odour\nBacterial growth\nBiofilm formation",

                    content2: "8,5-9,5",
                    content3:
                      "Aluminium corrosion\nMore aggressive to skin\nPaint damage\nFoaming tendency\nDestruction of plastic and rubber",
                  },
                  rows3: {
                    title: "Hardness (dH)",
                    content1: "Foaming (soft foam)",
                    content2: "8-45",
                    content3:
                      "Aluminium corrosion\nEmulsion breakdown\nSalt deposits\nOily deposits on surfaces\nReduction of emulsion life",
                  },
                  rows4: {
                    title: "Conductivity (χ)",

                    content1: "",
                    content2: "Up to 7 mS/cm",
                    content3:"Increased salt content\nElectrochemical corrosion",
                  },
                },
              },
            },
            VideoPage_4: {
              Title: "Impact on coolant life cycle",
              Short_Title: "Impact on coolant life cycle",
              Picture:VideoPage_4_En
            },
            VideoPage_5: {
              Title: "Reduction of coolant consumption",
              Short_Title: "Reduction of coolant consumption",
              Picture:VideoPage_5_En
            },
            VideoPage_6: {
              Title: "Solving problems with coolant",
              Short_Title: "Solving problems with coolant",
              Table: {
                tableheads: {
                  content1: "Possible causes",
                  content2: "Solution from «ASM coolant»",
                },
                rows: {
                  rows1: {
                    title: "Unpleasant odour",
                    content1:
                      "Active growth of microorganisms (drop in pH level)\nToo much foreign oil in the coolant tank\nCoolant system contamination",
                    content2:
                     `Regular automatic monitoring and adjustment of pH level and concentration\nInstallation of skimmers to remove foreign oil\nFine filter for coolant
                     `,
                  },
                  rows2: {
                    title: "Foaming",
                    content1:
                      "High emulsion concentration\nSoft water\nHigh emulsion temperature",
                    content2:
                      "Maintaining concentration at a preset level in automatic mode\nWater treatment system\nTemperature sensors\nMaintaining maximum coolant level in the tank",
                  },
                  rows3: {
                    title: "Corrosion",
                    content1:
                      "Low emulsion concentration\nHigh salt content\nPoor water quality",
                    content2:
                      "Maintaining concentration at a preset level in automatic mode\nWater treatment system\nEmulsion hardness monitoring",
                  },
                  rows4: {
                    title: "Allergic reactions",
                    content1:
                      "High emulsion concentration\nHigh pH level\nEmulsion contamination\nSpecial features",
                    content2:
                      "HRegular automatic monitoring and adjustment of pH level and concentration\nFine coolant filtration",
                  },
                  rows5: {
                    title: "Allergic reactions",
                    content1:
                      "Emulsion instability and breakdown\nIngress of foreign oil into the coolant system\nHigh salt content in coolant\nIncorrect emulsion preparation",
                    content2:
                      "Monitoring key parameters to maintain coolant stability\nWater treatment system for removal of hardness salts and impurities\n Mixer for finely dispersed emulsion preparation\nSkimmer for foreign oil collection",
                  },
                  rows6: {
                    title: "White deposit on parts and in the operating area",
                    content1:
                      "Salts inflowing in the emulsion with water build up and form crystallized deposit when dried",
                    content2:
                      "Water treatment system for removal of hardness salts and impurities",
                  },
                  rows7: {
                    title: "Increased concentrate consumption",
                    content1:
                      "Increase of emulsion concentration for filling up\nEmulsion becomes increasingly unstable due to salt buildup or contamination with foreign oils",
                    content2:
                      "Water treatment system\nMonitoring salt content and emulsion hardness",
                  },
                },
              },
            },
            VideoPage_7: {
              Title: "Technical specifications",
              Short_Title: "Technical specifications",
              Table: {
                tableheads: {
                  content1: "",
                  content2: "Range",
                  content3: "Increment",
                  content4: "Accuracy",
                },
                rows: {
                  rows1: {
                    title: "General characteristics",
                    columns1: {
                      content1: "Overall dimensions	1",
                      content2: "400x1,800x900",
                      content3: "LхHхW, mm",
                    },
                    columns2: {
                      content1: "Plant weight",
                      content2: "750",
                      content3: "kg",
                    },
                    columns3: {
                      content1: "Communication lines:	",
                      content2: "",
                      content3: "",
                    },
                    columns4: {
                      content1:
                        "- Power supply\n- Water supply (main line)\n- Water supply (intake)\n- Coolant supply\n- Coolant drain\n- CNC communication",
                      content2: "220\n20\n20\n12\n12",
                      content3: "V\nL/min\nL/min\nL/min\nL/min",
                    },
                    columns5: {
                      content1: "Clean water tank",
                      content2: "200",
                      content3: "L",
                    },
                    columns6: {
                      content1: "Concentrate tank",
                      content2: "40",
                      content3: "L",
                    },
                    columns7: {
                      content1: "Coolant filter	100	μm",
                      content2: "100",
                      content3: "μm",
                    },
                    columns8: {
                      content1: "Water filter	",
                      content2: "",
                      content3: "",
                    },
                    columns9: {
                      content1:
                        "-Stage 1 (BA)\n-Stage 2 (RR)\n-Stage 3 (SVS)",
                      content2: "10\n5\n0.6",
                      content3: "μm\μm\μm",
                    },
                    columns10: {
                      content1: "Concentrate mixer",
                      content2: "6-16",
                      content3: "%",
                    },
                    columns11: {
                      content1: "Pressure sensors (4 points)",
                      content2: "0-25",
                      content3: "bar",
                    },
                    columns12: {
                      content1: "Liquid level sensors (2 points)",
                      content2: "0-1500 (0-150)",
                      content3: "mm",
                    },
                    columns13: {
                      content1: "Circulation pumps (2 pcs)",
                      content2: "60",
                      content3: "L/min",
                    },
                    columns14: {
                      content1: "Communication protocols",
                      content2:
                        "Communication protocols	Web-server, MySQL, OPC UA, Modbus, MQTT, OwenCloud, and HTTP",
                      content3: "",
                    },
                    columns15: {
                      content1: "Total power consumption",
                      content2:
                        "3.5",
                      content3: "kW",
                    },
                  },
                  rows2: {
                    title: "Control system",
                    columns1: {
                      content1: "Control panel–controller",
                      content2: "OVEN SPK107",
                    },
                    columns2: {
                      content1: "Number of digital inputs",
                      content2: "12",
                    },
                    columns3: {
                      content1: "Number of digital outputs",
                      content2: "20",
                    },
                    columns4: {
                      content1: "Number of analog inputs",
                      content2: "16",
                    },
                    columns5: {
                      content1: "Communication interfaces	Ethernet",
                      content2:
                        "Ethernet, 3xRS-485, 2xRS-232,USB Host, USB Device, SD-card",
                    },
                    columns6: {
                      content1: "Data exchange protocols",
                      content2:
                        "Modbus (RTU, ASCII,TCP),OBEH,OPC UA (Server), SNMP (Manager/Agent)",
                    },
                  },
                  rows3: {
                    title: "pH measurement subsystem",
                    columns1: {
                      content1: "pH",
                      content2: "0-15",
                      content3: "0,01",
                      content4: "±0,02",
                    },
                    columns2: {
                      content1: "Температура, ℃",
                      content2: "0-100",
                      content3: "0,1",
                      content4: "±0,3",
                    },
                  },
                  rows4: {
                    title: "Specific electrical conductivity/salt content measurement subsystem",
                    columns1: {
                      content1: "Specific electrical conductivity, μS/cm",
                      content2: "0-200",
                      content3: "0,0001",
                      content4: "±(0,001+0,02*æ)",
                    },
                    columns2: {
                      content1: "Salt content, mg/dm3",
                      content2: "0-100",
                      content3: "0,0001",
                      content4: "±(0,001+0,025*С)",
                    },
                  },
                  rows5: {
                    title: "Concentration measurement subsystem",
                    columns1: {
                      content1: "Refraction",
                      content2: "1,3200-1,5400",
                      content3: "0,0001",
                      content4: "±0,0002",
                    },
                    columns2: {
                      content1: "Concentration, %",
                      content2: "0-90",
                      content3: "0,005",
                      content4: "0,005",
                    },
                    columns3: {
                      content1: "Prism material",
                      content2: "Synthetic sapphire",
                      content3: "",
                      content4: "",
                    },
                  },
                },
              },
            },
          },
          ModelPage: {
            Section_1: {
              Title: "Right section",
              Short_Title: "Right section",
              Points: {
                Points_1: {
                  Title: "Measurement subsystem",
                  Text: `•	Conductivity meter\n•	dH-meter/salinity meter\n•	pH meter/EMF\n•	Refractometer\n•	4 pressure sensors on filter cascades\n•	2 level sensors (clean water tank, concentrate tank)\n•	3 temperature sensors`,
                },
                Points_2: {
                  Title: "Coolant treatment subsystem",
                  Text: `•	Fine coolant filtration from mechanical contamination`,
                },
                Points_3: {
                  Title: "Control subsystem",
                  Text: `•	Touch-sensitive PLC-system\n•	4 modes of «ASM coolant» operation\n•	Emulsion filling-up and maintaining preset coolant level in the tank\n•	Blending special additives into coolant, as required`,
                },
                Points_4: {
                  Title: "Circulation and treatment subsystem",
                  Text: `•	Liquid supply and monitoring\n•	Coolant circulation mode, including for idle machines`,
                },
              },
            },
            Section_2: {
              Title: "Data Storage and Visualization Subsystem marker",
              Short_Title: "Data Storage and Visualization Subsystem marker",
            },
            Section_3: {
              Title: "Functions marker",
              Short_Title: "Functions marker",
              Picture:ModelPage_En
            },
            Section_4: {
              Title: "Left section",
              Short_Title: "Left section",
              Points: {
                Points_1: {
                  Title: "Water treatment and emulsion preparation system",
                  Text: `•	Consistent high quality of water treatment (Cascade of 3 treatment stages)\n•	Treated water tank\n•	Automatic mixer for finely dispersed homogeneous emulsion preparation\n•	Fine adjustment of the required emulsion concentration`,
                },
                Points_2: {
                  Title: "Treated water tank",
                },
                Points_3: {
                  Title: "Dosing system for additives",
                  Text: `•	Set of three dosing pumps and tanks with algorithm for blending additives, as required`,
                },
              },
            },
            Section_5: {
              Title: "Back section",
              Short_Title: "Back section",
            },
          },
        },
      },

      ///немецкий язык
      de: {
        translation: {
          SwitcherButtom:"Hilfestellung",
          BrowserLine:{
            MainPage:"ASM coolant",
            PhotoPage:"ASM coolant",
            VideoPage:"ASM coolant",
            ModelPage:"ASM coolant",
          },
          Nav:{
            There:{
              photo:"Gehen Sie zur Hauptseite",
              video:"Zur Übersicht gehen",
              model:"Gehen Sie zur Demo",
            },
            Back:{
              photo:"Gehen Sie zur Demo",
              video:"Gehen Sie zu den Spezifikationen",
            }
          },
          MainPage:{
            Picture:MainPage_De,
            SelectPage:"Gehen Sie zur nächsten Seite",
          },
          PhotoPage: {
            Title: "Einfluss des Kühlschmierstoffs auf die Ausrüstung",
            Picture:PhotoPage_De,
            PhotoPage_1: {
              Title: "Aggressive Einwirkung des Kühlschmierstoffs auf das Spindelaggregat",
              Short_Title: "     Aggressive Einwirkung des Kühlschmierstoffs auf das Spindelaggregat",
              Text: "Korrosion, Versalzung, Beschädigung von Dichtungen und Störungen der Elemente des Spindelaggregats entstehen infolge der unsachgemäßen Wartung des Kühlschmierstoffs, der fehlerhaften Emulsionsaufbereitung, der schlechten Wasserqualität, der inkorrekten Auswahl des Kühlschmierstoffs.",
            },
            PhotoPage_2: {
              Title: "Negativer Einfluss des Kühlschmierstoffs auf den Maschinenraum ",
              Short_Title: "Negativer Einfluss des Kühlschmierstoffs auf den Maschinenraum ",
              Text: "Der schlechte Zustand der Emulsion führt zu öligen Ablagerungen, Lackschäden, Niederschlägen innerhalb des Maschinenraums.",
            },
            PhotoPage_3: {
              Title: "Beschädigung der Werkzeugausrüstung",
              Short_Title: "Beschädigung der Werkzeugausrüstung",
              Text: "Die fehlende Wartung und die unsachgemäße Qualität des Kühlschmierstoffs verursacht ölige Ablagerungen im Werkzeugmagazin der Maschine.",
            },
            PhotoPage_4: {
              Title:
                "Einfluss auf die Elemente des Späneförderers und den Kühlschmierstoffbehälter (Bild hinzufügen, siehe Anhang) ",
              Short_Title:
                "Einfluss auf die Elemente des Späneförderers und den Kühlschmierstoffbehälter (Bild hinzufügen, siehe Anhang) ",
              Text1:
                "Bildung von Ablagerungen an den inneren Oberflächen des Späneförderers.",
              Text2:
                "Die Anreicherung von Fremdöl auf der Kühlschmierstoffoberfläche führt zu Biobefall, Leistungsabnahme der Bearbeitung, Verkürzung der Emulsionsbetriebsdauer, öligen Ablagerungen innerhalb der Maschine.",
            },
            PhotoPage_5: {
              Title: "Erhöhte Schaumbildung",
              Short_Title: "Erhöhte Schaumbildung",
              Text: "Die hohe Konzentration der Emulsion, die inkorrekte Aufbereitung des Kühlschmierstoffs, die Wasserqualität beeinflussen die Schaumbildung. Die große Schaummenge führt zu der Leistungsabnahme der Bearbeitung, dem Mehrverbrauch des Konzentrates, Stillstandzeiten.",
            },
            PhotoPage_6: {
              Title: "Ablagerungen in den Rohrleitungen der Maschine",
              Short_Title: "Ablagerungen in den Rohrleitungen der Maschine",
              Text: "Die unsachgemäße Wartung des Kühlschmierstoffs führt zu einem schnellen Wachstum und der Sammlung von Mikroorganismen im Kühlschmierstoffsystem, was die Nutzlebensdauer der Emulsion wesentlich reduziert.",
            },
            PhotoPage_7: {
              Title: "Einfluss des Kühlschmierstoffs auf die Werkstoffe",
              Short_Title: "Einfluss des Kühlschmierstoffs auf die Werkstoffe",
              Text: "Die fehlende Kontrolle des Kühlschmierstoffzustandes führt zur Korrosion sowohl bei NE-Metallen, als auch bei Eisenmetallen.",
            },
            PhotoPage_Q: {
              Title: "Referenzdaten zum Kühlschmierstoff",
              Short_Title: "Referenzdaten zum Kühlschmierstoff",
              Text1: {
                Title: "Funktion des Kühlschmierstoffs für Metallbearbeitung",
                Text1:
                  "Standzeiterhöhung der Werkzeuge und der Qualität der Oberflächenbehandlung.",
                Text2:
                "Einhaltung von notwendigen Toleranzen bei Bearbeitung von Werkstücken.",
                Text3: "Entfernung von Spänen aus der Schneidzone.",
                Text4:
                  "Erhöhung der Metallabtragsgeschwindigkeit und Verkürzung von Produktionszyklen.",
              },
              Text2: {
                Title: "Auswahl eines korrekten Kühlschmierstoffs für Metallbearbeitung",
                Text1:
                  "_Bei der Auswahl eines optimalen Kühlschmierstoffs für Metallbearbeitung sind folgende Faktoren zu beachten:",
                Text2: "Werkstoff oder Werkstoffkombination.",
                Text3: "Bearbeitungsart (Typ der Bearbeitungsoperation).",
                Text4: "Wasserqualität.",
                Text5: "Fachnormen und Beschränkungen.",
                Text6: "Fördersystem des Kühlschmierstoffs für Metallbearbeitung.",
                Text7: "Arbeitsschutz und Sicherheitsvorschriften.",
              },
            },
          },
          VideoPage: {
            Title: "Automatische Kühlschmierstoffüberwachungsanlage",
            VideoPage_1: {
              Title: "Aufgaben",
              Short_Title: "Aufgaben",
              Quotes_1:
                "Stabiler Bearbeitungsprozess ohne Abstellungen und Stillstandzeiten.",
              Quotes_2: "Maximale Betriebsdauer des Kühlschmierstoffs.",
              Quotes_3:
                "Seltener Kühlschmierstoffwechsel, Senkung der Kosten für Maschinenabstellung und Kühlschmierstoffentsorgung.",
              Quotes_4: "Unabhängigkeit der Kühlschmierstoffwartung.",
              Quotes_5:
                "Der menschliche Faktor ist ausgeschlossen: Aufbereitungs- und Vermessungsfehler, unzeitgemäße Wartung usw.",
              Quotes_6:
                "Erhöhte Lebensdauer der Ausrüstung: Verminderung des Risikos von Korrosion der Maschinenaggregaten, von Lackschäden.",
              Quotes_7: "Transparentes System der Kontrolle von Schlüsselkühlschmierstoffparametern.",
              Quotes_8:
                "Erhöhung der Produktionskultur (kein schlechter Geruch vom Kühlschmierstoff, keine klebrigen und nassen Fußböden).",
              Quotes_9:
                "Verhütung von typischen Problemen mit Kühlschmierstoffen.",
            },
            VideoPage_2: {
              Title: "Applikationsalgorithmus",
              Short_Title: "Applikationsalgorithmus",
              Picture:VideoPage_2_De
            },
            VideoPage_3: {
              Title: "Kühlschmierstoffparameter",
              Short_Title: "Kühlschmierstoffparameter",
              Table: {
                tableheads: {
                  content1: "Unter der Norm",
                  content2: "Normbereich",
                  content3: "Norm überschritten",
                },
                rows: {
                  rows1: {
                    title: "Konzentration (%)",
                    content1: "Senkung von pH\nSchlechter Geruch\n Werkzeugverschleiß\nUnstabilität der Emulsion\nStahlkorrosion",
                    content2: "6-10",
                    content3:
                      `Schaumbildung\nAggressive Hautwirkung\nVerschmoren von Öl, Rauch\nAblagerung\nHoher Verbrauch des Konzentrats`,
                  },
                  rows2: {
                    title: "Säuregrad (pH)",
                    content1:
                      `Werkzeugverschleiß\nStahlkorrosion\nUnstabilität der Emulsion\nSchlechter Geruch\nBakterienwachstum\nEntstehung einer Biofolie`,
                    content2: "8,5-9,5",
                    content3:
                      `Aluminiumkorrosion\nMehr aggressiv gegen Haut\nBeschädigung der Lackierung\nTendenz zur Schaumbildung\nZerstörung von Kunststoff und Gummi`,
                  },
                  rows3: {
                    title: "Härte (dH)",
                    content1: "Schaumbildung (Weichschaum)",
                    content2: "8-45",
                    content3:
                      `Aluminiumkorrosion\nEntmischung der Emulsion\nVersalzung\nÖlige Ablagerung auf Oberflächen\nVerminderung der Emulsionslebensdauer`,
                  },
                  rows4: {
                    title: "Leitfähigkeit (χ)",

                    content1: "",
                    content2: "bis 7 mS/cm",
                    content3:
                      `Erhöhter Salzgehalt\nElektrochemische Korrosion`,
                  },
                },
              },
            },
            VideoPage_4: {
              Title: "Einfluss auf den Lebenszyklus des Kühlmittels",
              Short_Title: "Einfluss auf den Lebenszyklus des Kühlmittels",
              Picture:VideoPage_4_De
            },
            VideoPage_5: {
              Title: "Senkung des Kühlschmierstoffverbrauchs",
              Short_Title: "Senkung des Kühlschmierstoffverbrauchs",
              Picture:VideoPage_5_De
            },
            VideoPage_6: {
              Title: "Lösung der Probleme mit Kühlschmierstoff",
              Short_Title: "Lösung der Probleme mit Kühlschmierstoff",
              Table: {
                tableheads: {
                  content1: "Mögliche Ursachen",
                  content2: "Lösung der Kühlschmierstoffüberwachungsanlage",
                },
                rows: {
                  rows1: {
                    title: "Schlechter Geruch",
                    content1:
                      `Biobefall (рН-Abnahme)\nGroße Fremdölmenge im Kühlschmierstoffbehälter\nVerunreinigungen im Kühlschmierstoffsystem`,
                    content2:
                      `Regelmäßige Kontrolle und Korrektur des рН-Wertes und der Konzentration im Automatikbetrieb\nEinstellung von Skimmern für die Entfernung von Fremdöl\nKühlschmierstofffeinfilter`,
                  },
                  rows2: {
                    title: "Schaumbildung",
                    content1:
                     `Hohe Emulsionskonzentration\nWeiches Wasser\nHohe Emulsionstemperatur`,

                    content2:
                      `Einhaltung der Konzentration auf dem vorgegebenen Niveau im Automatikbetrieb\nWasseraufbereitungssystem\nTemperatursensoren\nEinhaltung des maximalen Kühlschmierstoffstandes im Behälter\nSystem der Dosierung von Zusatzstoffen`,
                  },
                  rows3: {
                    title: "Korrosion",
                    content1:
                      `Niedrige Emulsionskonzentration\nHoher Gehalt an Salz\nSchlechte Wasserqualität`,
                    content2:
                      `Einhaltung der Konzentration auf dem vorgegebenen Niveau im Automatikbetrieb\nWasseraufbereitungssystem\nKontrolle der Emulsionshärte`,
                  },
                  rows4: {
                    title: "Allergische Reaktionen",
                    content1:
                    `Hohe Emulsionskonzentration\nHoher pH-Wert\nVerunreinigung der Emulsion\nIndividuelle Besonderheiten`,
                  content2:
                    `Regelmäßige Kontrolle und Korrektur des рН-Wertes und der Konzentration im Automatikbetrieb\nFeinfiltration des Kühlschmierstoffs`,
                },
                  rows5: {
                    title: "Ölige Ablagerung im Maschinenraum und Werkzeugwechselsystem",
                    content1:
                      `Unstabilität und Entmischung der Emulsion\nEindringen von Fremdöl ins Kühlschmierstoffsystem\nHoher Gehalt an Salz im Kühlschmierstoff\nInkorrekte Aufbereitung der Emulsion`,
                    content2:
                      `Kontrolle der Hauptparameter für die Einhaltung der Kühlschmierstoffstabilität\nWasseraufbereitungssystem für die Entfernung von Härtebildnern und Fremdstoffen\nMischer für die Aufbereitung von feindisperser Emulsion\nSkimmer für die Fremdölsammlung`,
                  },
                  rows6: {
                    title: "Weiße Ablagerung auf Werkstücken, im Maschinenraum",
                    content1:
                      `Die mit dem Wasser in die Emulsion eindringenden Salze sammeln sich und bilden beim Trocknen einen kristallisierten Beschlag `,
                    content2:
                      `Wasseraufbereitungssystem für die Entfernung von Härtebildnern und Fremdstoffen`,
                  },
                  rows7: {
                    title: "Erhöhter Verbrauch des Konzentrats",
                    content1:
                      `Erhöhung der Konzentration der zugegebenen Emulsion\nDie Emulsion wird immer unstabiler durch die Sammlung von Salzen oder Verunreinigung mit Fremdölen`,
                    content2:
                      `Wasseraufbereitungssystem\nKontrolle des Salzgehaltes, der Emulsionshärte`,
                  },
                },
              },
            },
            VideoPage_7: {
              Title: "Technische Daten",
              Short_Title: "Technische Daten",
              Table: {
                tableheads: {
                  content1: "",
                  content2: "Bereich",
                  content3: "Feinheit",
                  content4: "Genauigkeit",
                },
                rows: {
                  rows1: {
                    title: "Allgemeine Angaben",
                    columns1: {
                      content1: "Abmessungen",
                      content2: "1400х1800х900",
                      content3: "LхHхB, mmм",
                    },
                    columns2: {
                      content1: "Anlagengewicht",
                      content2: "750",
                      content3: "kg",
                    },
                    columns3: {
                      content1: "Kommunikationsleitungen",
                      content2: "",
                      content3: "",
                    },
                    columns4: {
                      content1:
                        `Stromversorgung\nWasserzufuhr (Magistral)\nWasserzufuhr (Einfassung)\nKühlschmierstoffzufuhr\nKühlschmierstoffaustrag\nKommunikation von CNC-Maschinen`,
                      content2: "220\n20\n20\n12\n12",
                      content3: `V\nl/min\nl/min\nl/min\nl/min`,
                    },
                    columns5: {
                      content1: "Reinwasserbehälter",
                      content2: "200",
                      content3: "Liter",
                    },
                    columns6: {
                      content1: "Konzentratbehälter",
                      content2: "40",
                      content3: "Liter",
                    },
                    columns7: {
                      content1: "Kühlschmierstofffilter",
                      content2: "100",
                      content3: "µm",
                    },
                    columns8: {
                      content1: "Wasserfilter",
                      content2: "",
                      content3: "",
                    },
                    columns9: {
                      content1:
                        `Stufe 1 (BA)\nStufe 2 (RR)\n 3 (SWS)`,
                      content2: "10\n5\n0,6",
                      content3: "µm\µm\µm",
                    },
                    columns10: {
                      content1: "Konzentratmischer",
                      content2: "6-16",
                      content3: "%",
                    },
                    columns11: {
                      content1: "Drucksensoren (4 Stellen)",
                      content2: "0-25",
                      content3: "bar",
                    },
                    columns12: {
                      content1: "Flüssigkeitsstandgeber (2 Stellen)",
                      content2: "0-1500 (0-150)",
                      content3: "mm",
                    },
                    columns13: {
                      content1: "Kreislaufpumpen (2 Stk.)",
                      content2: "60",
                      content3: "l/min",
                    },
                    columns14: {
                      content1: "Kommunikationsprotokolle",
                      content2:
                        "Web-server, MySQL, OPC UA, Modbus , MQTT, OwenCloud, HTTP",
                      content3: "",
                    },
                    columns15: {
                      content1: "Gesamtanschlussleistung",
                      content2:
                        "3.5",
                      content3: "kW",
                  },
                  },
                  rows2: {
                    title: "Steuersystem",
                    columns1: {
                      content1: "Bedien- und Kontrolltafel ",
                      content2: "OWEN SPK107",
                    },
                    columns2: {
                      content1: "Anzahl Digitaleingänge",
                      content2: "12",
                    },
                    columns3: {
                      content1: "Anzahl Digitalausgänge",
                      content2: "20",
                    },
                    columns4: {
                      content1: "Anzahl Analogeingänge",
                      content2: "16",
                    },
                    columns5: {
                      content1: "Kommunikationsschnittstellen",
                      content2:
                        "Ethernet, 3xRS-485, 2xRS-232,USB Host, USB Device, SD-card",
                    },
                    columns6: {
                      content1: "Datenübertragungsprotokoll",
                      content2:
                        "Modbus (RTU, ASCII,TCP),OBEH,OPC UA (Server), SNMP (Manager/Agent)",
                    },
                  },
                  rows3: {
                    title: "pH-Messung-Subsystem",
                    columns1: {
                      content1: "pH",
                      content2: "0-15",
                      content3: "0,01",
                      content4: "±0,02",
                    },
                    columns2: {
                      content1: "Temperatur, °C",
                      content2: "0-100",
                      content3: "0,1",
                      content4: "±0,3",
                    },
                  },
                  rows4: {
                    title: "Subsystem für die Messung der spezifischen Leitfähigkeit/ des Salzgehaltes",
                    columns1: {
                      content1: "Spezifische Leitfähigkeit, µS/cm",
                      content2: "0-200",
                      content3: "0,0001",
                      content4: "±(0,001+0,02*æ)",
                    },
                    columns2: {
                      content1: "Salzgehalt, mg/ dm3",
                      content2: "0-100",
                      content3: "0,0001",
                      content4: "±(0,001+0,025*С)",
                    },
                  },
                  rows5: {
                    title: "Subsystem für die Messung der Konzentration",
                    columns1: {
                      content1: "Brechung",
                      content2: "1,3200-1,5400",
                      content3: "0,0001",
                      content4: "±0,0002",
                    },
                    columns2: {
                      content1: "Konzentration, %",
                      content2: "0-90",
                      content3: "0,005",
                      content4: "0,005",
                    },
                    columns3: {
                      content1: "Werkstoff des Prismas",
                      content2: "Synthetischer Saphir",
                      content3: "",
                      content4: "",
                    },
                  },
                
                },
              },
            },
         },
          ModelPage: {
            Section_1: {
              Title: "Rechte Sektion",
              Short_Title: "Rechte Sektion",
              Points: {
                Points_1: {
                  Title: "Subsystem für Messungen",
                  Text: `•	Leitfähigkeitsmesser\n•	dH-Messer / Salzgehaltmesser\n•	pH-Messer / elektrische Spannung\n•	Brechungsmesser\n•	4 Drucksensoren an Filterkaskaden\n•	2 Füllstandsgeber (Reinwasserbehälter, Konzentratbehälter)\n•	3 Temperatursensoren`,
                },
                Points_2: {
                  Title: "Subsystem der Kühlschmierstoffreinigung",
                  Text: `•	Feinfiltration des Kühlschmierstoffs von Fremdstoffen`,
                },
                Points_3: {
                  Title: "Subsystem der Steuerung",
                  Text: `•	Industriekontroller mit Sensorsteuerung\n•	4 Betriebsmodi der Kühlschmierstoffüberwachungsanlage\n•	Zugabe der Emulsion und Einhaltung des vorgegebenen Kühlschmierstoffstandes im Behälter\n•	Kühlschmierstofflegierung bei Bedarf`,
                },
                Points_4: {
                  Title: "Kreislauf- und Reinigungssubsystem",
                  Text: `•	Flüssigkeitszufuhr und -kontrolle\n•	Kühlschmierstoffzirkulationsbetrieb, u.a. für stillstehende Maschinen`,
                },
              },
            },
            Section_2: {
              Title: "Subsystem für Datenspeicherung und Visualisierung",
              Short_Title: "Subsystem für Datenspeicherung und Visualisierung",
              Text: `•	Dashboard für den Kühlschmierstoffzustand
              •	Web-Oberfläche für die Kommunikation mit Kühlschmierstoffüberwachungsanlage
              •	Zuverlässige Berichterstattung, Datenspeicherung in der Datenbank, prädiktive Analytik
              •	Notfall- und Wartungsarbeiten-Meldesystem
              `,
            },
            Section_3: {
              Title: "Hauptfunktionen",
              Short_Title: "Hauptfunktionen",
              Picture:ModelPage_De
            },
            Section_4: {
              Title: "Linke Sektion",
              Short_Title: "Linke Sektion",
              Points: {
                Points_1: {
                  Title: "Wasseraufbereitungssystem und Aufbereitung der Emulsion ",
                  Text: `•	Stabile hohe Qualität der Wasserreinigung (Kaskade aus 3 Reinigungsstufen)\n•	Reinwasserbehälter\n•	Automatischer Mischer für die Aufbereitung von feindisperser homogener Emulsion\n•	Präzise Einstellung der erforderlichen Emulsionskonzentration`,
                },
                Points_2: {
                  Title: "Reinwasserbehälter",
                },
                Points_3: {
                  Title: "System der Dosierung von Zusatzstoffen",
                  Text: `•	Satz aus 3 Dosierpumpen und Behältern mit einem bei Bedarf angewandten Algorithmus der Beimischung `,
                },
              },
            },
            Section_5: {
              Title: "Rückseite Section",
              Short_Title: "Rückseite Section ",
            },
          },
        },
      },
    },
    lng: "ru", // if you're using a language detector, do not define the lng option
    fallbackLng: "ru",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
